// extracted by mini-css-extract-plugin
export var backdropBlur = "_lr-0";
export var contentCard = "_lr-5";
export var frame = "_lr-2";
export var image = "_lr-4";
export var imagePane = "_lr-3";
export var modal = "_lr-1";